/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "../../EmployeeScreens/EMPleave/EMPLeaves.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight, MdSearch, MdDelete, MdOutlineModeEdit } from "react-icons/md";
import { Modal } from "react-bootstrap";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import {
  Apiurl,
  GetLoginRole,
  GetToken,
  RemoveUserSession,
  formatNoOfDays,
} from "../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../../Components/loader/loader";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const EMPLeaves = () => {
  const LoginToken = GetToken();
  const navigate = useNavigate();
  const getUserRole = GetLoginRole();

  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [leaveRequest, setLeaveRequest] = useState([]);
  const [leaveRequestDuplicate, setLeaveRequestDuplicate] = useState([]);
  const [showModalNew, setShowModalNew] = useState(false);
  const [searchFilter, setSearchFilter] = useState("LeaveTypes");
  const [errorLeaveType, setErrorLeaveType] = useState(false);
  const [deleteClickable, setDeleteClickable] = useState("");
  const [expandedCards, setExpandedCards] = useState({});

  const [deleteLeave, setDeleteLeave] = useState({
    IdDelete: "",
  });

  const handleAttendanceSearch = () => {
    setLoading(true);

    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/TotalLeaves`,
    };

    axios(option)
      .then((e) => {
        const data = JSON.parse(e?.data?.data);
        setLeaveRequest(data);
        setLeaveRequestDuplicate(data);

        if (e?.status === 200) {
          toast.success(e?.data?.message);
        }
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);

        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    handleAttendanceSearch();
  }, []);

  const handleDataSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();

    if (!searchTerm) {
      setLeaveRequest(leaveRequestDuplicate);
      return;
    }

    const filteredData = leaveRequestDuplicate.filter((item) => {
      if (searchFilter === "LeaveTypes") {
        return item?.LeaveTypes?.Name?.toLowerCase()?.includes(searchTerm);
      }

      if (searchFilter === "Status") {
        return item?.Status?.toLowerCase()?.includes(searchTerm);
      }

      return false;
    });

    setLeaveRequest(filteredData);
  };

  const handleLeaveDelete = (item) => {
    setDeleteClickable(item);
    setShowModalNew(true);
  };

  const handleCloseModal = () => {
    setShowModalNew(false);
    setDeleteLeave({
      IdDelete: "",
    });
    setErrorLeaveType(false);
  };

  const modalValidate = () => {
    if (deleteLeave?.IdDelete?.trim() === "") {
      toast.error("Please enter Reason");
      return false;
    }
    return true;
  };

  const handleDeleteLeave = () => {
    if (!modalValidate()) return;
    setLoading(true);

    const data = {};
    data.Id = deleteClickable?.Id;
    data.CancelReason = deleteLeave?.IdDelete;

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/CancelLeave`,
      data: { data: JSON.stringify(data) },
    };

    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          handleCloseModal();
          handleAttendanceSearch();
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const toggleReadMore = (index) => {
    setExpandedCards((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const getStatusButtonClass = (status) => {
    return status === "Cancelled" ||
      status === "Rejected By Team Lead" ||
      status === "Rejected By HR" ||
      status === "Rejected By Admin"
      ? "EMP-Leaves-table-Rejected-button"
      : status === "ApprovedByTeamLead" ||
        status === "YetToBeApprovedByTeamLead" ||
        status === "ApprovedByHR" ||
        status === "YetToBeApprovedByHR" ||
        status === "YetToBeApprovedByAdmin" ||
        status === "Approved By Admin"
      ? "EMP-YetToBeApprovedByTeamLead-button"
      : "EMP-Leaves-table-Approved-button";
  };

  const renderActionButtons = (item) => {
    return item?.Status === "YetToBeApprovedByTeamLead" ? (
      <>
        <MdOutlineModeEdit
          className="handel-Edit-button"
          onClick={() =>
            navigate("/Emp/ApplyLeaves", {
              state: { leaveRequestData: item },
            })
          }
        />
        <MdDelete
          className="handel-delete-button"
          onClick={() => handleLeaveDelete(item)}
        />
      </>
    ) : item?.Status === "Pending At Admin" ||
      item?.Status === "Pending At HR" ||
      item?.Status === "Pending At Team Lead" ? (
      <>
        <MdOutlineModeEdit
          className="handel-Edit-button"
          onClick={() =>
            navigate("/Emp/ApplyLeaves", {
              state: { leaveRequestData: item },
            })
          }
        />
        <MdDelete
          className="handel-delete-button"
          onClick={() => handleLeaveDelete(item)}
        />
      </>
    ) : item?.Status === "Approved By Admin" ? null : (
      <MdDelete
        className="handel-delete-button-new"
        onClick={() => handleLeaveDelete(item)}
      />
    );
  };

  const filteredLeaves = leaveRequest?.filter(
    (item) => !(item?.Status === "Cancelled" && getUserRole === "TeamLead")
  );

  return (
    <>
      {loading ? <Loader /> : null}

      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <div
          className={
            showSidebar
              ? "EMP-main-container-of-all-employees-page"
              : "EMP-main-container-of-all-employees-page-new"
          }
        >
          <div className="EMp-inner-container-of-all-employees-page">
            <div className="EMP-header-of-employees-page row">
              <div className="EMP-all-employee-text col">
                <h4>Leave Requests</h4>
              </div>

              <div className="EMP-all-employees-directory col">
                <div className="EMP-home-icon-header">
                  <BiHomeAlt className="EMP-home-icon-header-inn" />
                </div>
                <div className="EMP-arrow-icon-header">
                  <MdKeyboardArrowRight />
                </div>
                <div className="EMp-leave-employee-text-header">
                  <p>Leave Management</p>
                </div>
                <div className="arrow-icon-header">
                  <MdKeyboardArrowRight />
                </div>
                <div className="EMP-all-employee-text-header">
                  <p>Leave Requests</p>
                </div>
              </div>
            </div>
          </div>

          <div className="EMP-body-part-outer-container">
            <div className="EMP-inner-body-container-of-employee-table row-12">
              <div className="first-side-in-body-header col-6">
                <div className="EMP-employee-text-in-body">
                  <h2>Leave Requests</h2>
                </div>

                <div className="EMP-search-container">
                  <select
                    className="EMP-search-filter"
                    value={searchFilter}
                    onChange={(e) => setSearchFilter(e.target.value)}
                  >
                    <option value="LeaveTypes">Leave Type</option>
                    <option value="Status">Status</option>
                  </select>

                  <div className="EMP-search-input-wrapper">
                    <MdSearch className="EMP-search-icon-in-input" />
                    <input
                      type="text"
                      placeholder={`Search by ${
                        searchFilter === "LeaveTypes" ? "Leave Type" : "Status"
                      }`}
                      onChange={(e) => handleDataSearch(e)}
                      className="EMP-search-input"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="main-class-for-table-in-leavemanagement">
              {/* Desktop / Web table */}
              <div className="EMP-desktop-table-view">
                <table className="table-of-employee-leaves table-of-employee-approval">
                  <thead className="thead-of-emp-table-leaves">
                    <tr>
                      <th className="approve_Sr">Sr. No.</th>
                      <th className="approve_Date">Date</th>
                      <th className="approve_Type">Leave Type</th>
                      <th className="approve_From">Leave From</th>
                      <th className="approve_To">Leave To</th>
                      <th className="approve_Days">No Of Days</th>
                      <th className="approve_Reason">Employee Reason</th>
                      <th className="approve_Status">Status</th>
                      <th className="approve_Reason">Approval Reason</th>
                      <th className="approve_Date-fix-on-mobile-view">Action</th>
                    </tr>
                  </thead>

                  <tbody className="tbody-ofemp-table-leaves">
                    {filteredLeaves?.length ? (
                      filteredLeaves.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{moment(item?.AppliedDate).format("DD MMM YYYY")}</td>
                          <td>{item?.LeaveTypes?.Name}</td>
                          <td>{moment(item?.StartDate).format("DD MMM YYYY")}</td>
                          <td>{moment(item?.EndDate).format("DD MMM YYYY")}</td>
                          <td>{formatNoOfDays(item?.NumberofDays)}</td>
                          <td>{item?.Reason}</td>
                          <td>
                            <button className={getStatusButtonClass(item?.Status)}>
                              {item?.Status}
                            </button>
                          </td>
                          <td>{item?.RejectionReason ? item?.RejectionReason : "-"}</td>
                          <td className="fixThe_icons">{renderActionButtons(item)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr className="no-record-found-tr">
                        <td colSpan="10">No record found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Mobile / Tablet cards */}
              <div className="EMP-mobile-card-view">
                {filteredLeaves?.length ? (
                  filteredLeaves.map((item, index) => (
                    <div className="EMP-leave-card" key={index}>
                      <div className="EMP-leave-card-header">
                        <h3>{item?.LeaveTypes?.Name || "-"}</h3>
                        <span className="EMP-leave-card-index">#{index + 1}</span>
                      </div>

                      <div className="EMP-leave-card-body">
                        <div className="EMP-leave-card-row">
                          <span className="EMP-leave-card-label">Date</span>
                          <span className="EMP-leave-card-value">
                            {moment(item?.AppliedDate).format("DD MMM YYYY")}
                          </span>
                        </div>

                        <div className="EMP-leave-card-row">
                          <span className="EMP-leave-card-label">Leave From</span>
                          <span className="EMP-leave-card-value">
                            {moment(item?.StartDate).format("DD MMM YYYY")}
                          </span>
                        </div>

                        <div className="EMP-leave-card-row">
                          <span className="EMP-leave-card-label">Leave To</span>
                          <span className="EMP-leave-card-value">
                            {moment(item?.EndDate).format("DD MMM YYYY")}
                          </span>
                        </div>

                        <div className="EMP-leave-card-row">
                          <span className="EMP-leave-card-label">No Of Days</span>
                          <span className="EMP-leave-card-value">
                            {formatNoOfDays(item?.NumberofDays)}
                          </span>
                        </div>

                        <div className="EMP-leave-card-row EMP-leave-card-row-full">
                          <span className="EMP-leave-card-label">Employee Reason</span>
                          <span className="EMP-leave-card-value EMP-leave-reason-value">
                            {item?.Reason
                              ? expandedCards[index]
                                ? item?.Reason
                                : item?.Reason.length > 80
                                ? `${item?.Reason.slice(0, 80)}...`
                                : item?.Reason
                              : "-"}

                            {item?.Reason && item?.Reason.length > 80 && (
                              <button
                                type="button"
                                className="EMP-read-more-btn"
                                onClick={() => toggleReadMore(index)}
                              >
                                {expandedCards[index] ? "Read Less" : "Read More"}
                              </button>
                            )}
                          </span>
                        </div>

                        <div className="EMP-leave-card-row">
                          <span className="EMP-leave-card-label">Status</span>
                          <span className="EMP-leave-card-value">
                            <button className={getStatusButtonClass(item?.Status)}>
                              {item?.Status}
                            </button>
                          </span>
                        </div>

                        <div className="EMP-leave-card-row EMP-leave-card-row-full">
                          <span className="EMP-leave-card-label">Approval Reason</span>
                          <span className="EMP-leave-card-value">
                            {item?.RejectionReason ? item?.RejectionReason : "-"}
                          </span>
                        </div>

                        <div className="EMP-leave-card-actions">
                          {renderActionButtons(item)}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="EMP-no-card-record">No record found</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModalNew && (
        <div className="modal show edit-leaveModal" style={{ display: "block" }}>
          <Modal.Dialog>
            <Modal.Header
              className="delete-modal-header"
              closeButton
              onClick={handleCloseModal}
            >
              <Modal.Title>Cancel Confirmation</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="textarea-validate">
                <label htmlFor="" className="reason-label-in-modal-of-delete-leave">
                  Reason
                </label>
                <textarea
                  type="text"
                  className="textarea-for-delete-leave-api"
                  value={deleteLeave?.IdDelete}
                  onChange={(e) =>
                    setDeleteLeave({
                      ...deleteLeave,
                      IdDelete: e?.target?.value,
                    })
                  }
                />
                {errorLeaveType === "userLeaveType" && !deleteLeave?.IdDelete ? (
                  <span className="reason-delete-leave">Reason is required.</span>
                ) : null}
              </div>
            </Modal.Body>

            <Modal.Footer className="Delete-fotter">
              <button className="Delete-modal-close-button" onClick={handleCloseModal}>
                Close
              </button>
              <button className="Delete-modal-delete-button" onClick={handleDeleteLeave}>
                Delete
              </button>
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      )}
    </>
  );
};

export default EMPLeaves;